import { React, useEffect, useRef, useState } from "react";
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import aboutSlider1 from "../../assets/about-1.svg";
import aboutSlider2 from "../../assets/about-2.svg";
import aboutSlider3 from "../../assets/about-3.svg";
import aboutSlider4 from "../../assets/about-4.svg";
import leftCoin from "../../assets/left-coin.svg";
import rightCoin from "../../assets/right-coin.svg";
import Close_black from "../../assets/close_black.svg";
import Close_white from "../../assets/white-close.svg";
import aboutIocon1 from "../../assets/apple-about.svg";
import aboutIocon2 from "../../assets/google-about.svg";
import aboutIocon3 from "../../assets/facebook-about.svg";

function AboutUs() {
    const [provider, setProvider] = useState(null)
    const [profile, setProfile] = useState(null)
    const myRef = useRef(null)
    const handleFocus = () => {
        myRef.current.focus()
    }

    return (
        <>
            {/* About Us Popup HTML Start Here  */}
            <div
                className="modal fade about-us-overlay"
                id="aboutus-modal"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="exampleModalLabel"
                // data-backdrop="static" data-keyboard="false"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-centered custom-popup aboutus-popup" role="document">
                    <div className="modal-content   ">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">
                                About Us
                            </h5>
                            <button type="button" className="close" data-dismiss="modal">
                                <span className="displaySpan" aria-hidden="true">
                                    <img src={Close_white} alt="" />
                                </span>
                            </button>
                        </div>
                        <div className="modal-body ">
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="aboutus-content">
                                        <div className="coin-right"><img src={leftCoin} alt="" /></div>
                                        <div className="coin-left "><img src={rightCoin} alt="" /></div>
                                        <p>How do I earn money using my social accounts? </p>
                                        <span className="displaySpan">CreatorPro is the solution. Link your social accounts and get access to exciting monetization opportunities.</span>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="about-OwlCarousel">
                                        <OwlCarousel
                                            className="owl-theme"
                                            loop={true}
                                            margin={20}
                                            nav={false}
                                            autoWidth={false}
                                            autoplay={true}
                                            responsive={{
                                                0: {
                                                    items: 1,
                                                    stagePadding: 0,
                                                },
                                                600: {
                                                    items: 1,
                                                    stagePadding: 30,
                                                },
                                                1000: {
                                                    items: 1,
                                                },
                                            }}
                                        >
                                            <div className="item">
                                                <div className="aboutus-slider-wrap">
                                                    <div className="aboutus-slider-card">
                                                        <img src={aboutSlider1} alt="" />
                                                        <p>45+ performance metrics tracked in one place </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="item">
                                                <div className="aboutus-slider-wrap">
                                                    <div className="aboutus-slider-card">
                                                        <img src={aboutSlider2} alt="" />
                                                        <p>10000+ brands are waiting for colloborations </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="item">
                                                <div className="aboutus-slider-wrap">
                                                    <div className="aboutus-slider-card">
                                                        <img src={aboutSlider3} alt="" />
                                                        <p>Connect more accounts and monitor your performance</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="item">
                                                <div className="aboutus-slider-wrap">
                                                    <div className="aboutus-slider-card">
                                                        <img src={aboutSlider4} alt="" />
                                                        <p>Choose from 20000+ affiliate products</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </OwlCarousel>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* About Us Popup HTML Start Here  */}
        </>
    )
}

export default AboutUs